import { MutationTree } from "vuex";
import { CourseState } from "../../interface";
import { updateCourseDetail } from "./mutation-types";

export const mutations: MutationTree<CourseState> = {
  [updateCourseDetail]: (
    state: CourseState,
    payload: { courseId: string; detail: any[] }
  ) => {
    state.courseMap[payload.courseId] = payload.detail;
  }
};
